import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export const YES_NO = 'YES_NO';
export const OK_ONLY = 'OK_ONLY';

@Injectable()
export class AlertService {
  observable: Subject<any> = null;
  show = false;
  type: string;
  title: string;
  message: string;
  message_small: string;

  showAlert() {
    this.show = true;
  }

  hideAlert() {
    this.show = false;
  }

  popupYesNo(title: string, message: string, message_small = ''): Observable<boolean> {
    this.observable = new Subject();
    this.type = YES_NO;
    this.title = title;
    this.message = message;
    this.message_small = message_small;
    this.showAlert();
    return this.observable;
  }

  popupOKOnly(title: string, message: string, message_small = ''): Observable<number> {
    this.observable = new Subject();
    this.type = OK_ONLY;
    this.title = title;
    this.message = message;
    this.message_small = message_small;
    this.showAlert();
    return this.observable;
  }

  onCurtain() {
    switch (this.type) {
      case OK_ONLY:
        this.answerOK();
        break;
      case YES_NO:
        this.answerNo();
        break;
      default:
        this.answerOK();
    }
  }

  answerOK() {
    this.observable.next(1);
    this.observable.complete();
    this.hideAlert();
  }

  answerNo() {
    this.observable.next(false);
    this.observable.complete();
    this.hideAlert();
  }

  answerYes() {
    this.observable.next(true);
    this.observable.complete();
    this.hideAlert();
  }
}
